export default __webpack_public_path__ + "static/media/license_fee.fc409c16.svg";